module.exports = __webpack_public_path__ + "img/distribute.5051e005.svg";